import styled from 'styled-components';

const PrivacyPolicyTemplateStyle = styled.section`
	--distanceTitle: var(--sp13x);
	--distanceEditor: var(--sp9x);
	--distanceItems: var(--sp12x);

	margin-top: var(--distanceTitle);

	.wrapper-items {
		margin-top: var(--distanceEditor);
		display: flex;
		flex-direction: column;
		gap: var(--distanceItems);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceTitle: var(--sp8x);
		--distanceEditor: var(--sp5x);
		--distanceItems: var(--sp10x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceTitle: var(--sp7x);
		--distanceEditor: var(--sp4x);
		--distanceItems: var(--sp8x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceTitle: var(--sp9x);
		--distanceItems: var(--sp7x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceTitle: var(--sp7x);
		--distanceEditor: var(--sp3x);
		--distanceItems: var(--sp6x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceTitle: var(--sp6x);
		--distanceEditor: var(--sp4x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceTitle: var(--sp4x);
		--distanceItems: var(--sp4x);
	}
`;
export default PrivacyPolicyTemplateStyle;
